import React from "react";

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={70} height={70} fill="none">
      <path
        fill="#535B65"
        d="M7 61.25c0 .928 2.95 1.819 8.201 2.475C20.452 64.38 27.574 64.75 35 64.75s14.548-.369 19.799-1.025C60.05 63.068 63 62.178 63 61.25c0-.928-2.95-1.819-8.201-2.475C49.548 58.12 42.426 57.75 35 57.75s-14.548.369-19.799 1.025C9.95 59.432 7 60.322 7 61.25Z"
        opacity={0.1}
      />
      <path
        fill="#535B65"
        d="M7.98 25.76c0 .595.455 1.05 1.05 1.05s1.05-.455 1.05-1.05-.455-1.05-1.05-1.05c-.56 0-1.05.49-1.05 1.05Zm55.37 31.115c-1.33.35-1.61.63-1.925 1.925-.35-1.33-.63-1.61-1.925-1.925 1.295-.35 1.61-.63 1.925-1.925.315 1.295.595 1.61 1.925 1.925Zm-49.525-34.79c-1.715.455-2.065.805-2.52 2.52-.455-1.715-.805-2.065-2.52-2.52 1.715-.455 2.065-.84 2.52-2.52.42 1.715.805 2.065 2.52 2.52Zm42-6.02c-1.05.28-1.26.49-1.54 1.54-.28-1.05-.49-1.26-1.54-1.54 1.05-.28 1.26-.49 1.54-1.54.245 1.05.49 1.26 1.54 1.54Zm4.515-5.39c-2.73.7-3.29 1.295-4.025 4.025-.7-2.73-1.295-3.29-4.025-4.025 2.73-.7 3.29-1.295 4.025-4.025.7 2.695 1.295 3.29 4.025 4.025ZM58.8 37.73v-.07c0-.07-.035-.105-.035-.175v-.035L51.24 17.815a8.048 8.048 0 0 0-7.665-5.565H26.46c-3.5 0-6.58 2.24-7.665 5.565L11.27 37.45v.035c-.035.07-.035.105-.035.175V51.8a8.051 8.051 0 0 0 8.05 8.05h31.5a8.051 8.051 0 0 0 8.05-8.05v-14c-.035-.035-.035-.035-.035-.07ZM20.755 18.55s0-.035.035-.035c.77-2.52 3.08-4.165 5.67-4.165h17.08c2.59 0 4.9 1.645 5.705 4.13 0 0 0 .035.035.035l6.965 18.2H40.25c-.595 0-1.05.455-1.05 1.05 0 2.31-1.89 4.2-4.2 4.2-2.31 0-4.2-1.89-4.2-4.2 0-.595-.455-1.05-1.05-1.05H13.79l6.965-18.165ZM56.7 51.8c0 3.29-2.66 5.95-5.95 5.95h-31.5c-3.29 0-5.95-2.66-5.95-5.95V38.85h15.505A6.285 6.285 0 0 0 35 44.1a6.285 6.285 0 0 0 6.195-5.25H56.7V51.8Z"
        opacity={0.5}
      />
      <path
        fill="#535B65"
        d="M35 39.55c-.98 0-1.75-.77-1.75-1.75v-3.5H17.325l5.74-14.98.035-.07c.49-1.47 1.82-2.45 3.36-2.45h17.08c1.54 0 2.87.98 3.36 2.45l.035.07 5.74 14.98H36.75v3.5c0 .98-.77 1.75-1.75 1.75Z"
        opacity={0.2}
      />
    </svg>
  );
}

export default Icon;
